import {
   Box,
   Button,
   useDisclosure,
   Card,
   Flex,
   Text,
   useColorModeValue,
   Input,
   IconButton,
   useBreakpointValue,
   Badge,
   ModalFooter,
   Switch,
   SimpleGrid,
   ModalBody,
   ModalCloseButton,
   ModalHeader,
   ModalContent,
   ModalOverlay,
   Modal,
   FormLabel,
   Menu,
   Center,
   Spinner,
   useColorMode,
   Fade,
   Icon,
   Select,
   Checkbox,
   VStack,
   FormControl,
} from '@chakra-ui/react';
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { downloadPDF, downloadExcel, useServerPagination } from '../../../utils/DataTableUtils';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import {
   addVoucher,
   clearPendingVoucher,
   deleteVoucher,
   getBankVoucher,
   getOneVoucher,
   importVoucherExcel,
   multiDeleteVoucher,
   updateVoucher,
   voucherNextPrev,
} from '../../../redux/actions/voucher';
import { getAccount, getAccountForCashBank } from '../../../redux/actions/account';
import { toast } from 'react-toastify';
import { DownloadIcon, SearchIcon } from '@chakra-ui/icons';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { getDaybook, getDaybookForPayments } from '../../../redux/actions/daybook';
import LogView from 'components/salesDetails/LogView';

// filter
import filter from 'assets/img/nfts/filter.svg';
import PaymentCaseForm from '../cash/PaymentcaseForm';
import PaymentCaseFormEdit from '../cash/PaymentcaseFormEdit';
import DeleteDialog from '../masters/components/DeleteDialog';
import { DAYBOOK_TYPE } from 'constants';

import { motion } from 'framer-motion';
import moment from 'moment';
import { useUser, useGlobal } from 'contexts';
import { IoFilterOutline } from 'react-icons/io5';
import CashBankFilterModal from '../cash/CashBankFilterModal';
import ViewSingleCashBankData from 'components/UIcomponents/ViewSingleCashBankData';
import { formatAmountWithLabel } from 'utils/util';
import { AiTwotoneBook } from 'react-icons/ai';
import { BsEye, BsFileEarmarkExcel } from 'react-icons/bs';
import { postColumnsHideShow } from '../../../redux/actions/utility';
import DynamicTable from '../masters/components/DynamicAllDataTable';
import { createColumnHelper, getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import DeletePasswordModal from '../sales/Pages/SalesInvoiceMaster/DeletePasswordModal';
import MultiDeletePasswordModal from 'views/admin/sales/Pages/SalesInvoiceMaster/MultiDeletePasswordModal';
import { FiRefreshCcw, FiUploadCloud } from 'react-icons/fi';
import { X } from 'lucide-react';
import Loader from '../default/Loader';
import { getItem } from '../../../redux/actions/item';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import AccountSelect from 'components/AccountSelect/AccountSelect';

const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

export default function Bank() {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const { user } = useUser();
   const companyId = user?.loginhistory?.companyId;
   const [editingId, setEditingId] = useState(null);
   const [editingData, setEditingData] = useState({});
   const voucher = useSelector((state) => state.voucher.bankList || []);
   const singleEntity = useSelector((state) => state.voucher?.single);
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [multiPass, setMultiPass] = useState(false);
   const [multiDeleteData, setMultiDeleteData] = useState(null);
   const [dataId, setDataId] = useState(null);
   const daybookData = useSelector((state) => state.daybook?.list || []);
   const voucher_prev_next = useSelector((state) => state.voucher?.voucher_prev_next || null);
   const totalCount = useSelector((state) => state.voucher?.totalCount || 1);
   const userData = useSelector((state) => state?.account?.listForCashBank || []);
   const pagination = useSelector((state) => state.voucher?.pagination || []);
   const [totalPendingAccount, setTotalPendingAccount] = useState(0);
   const location = useLocation();
   const navigate = useNavigate();
   const [searchParams] = useSearchParams();
   const isBankPage = location.pathname.includes('/bank');
   const hoverBg = useColorModeValue('gray.200', 'gray.600');
   const [isRotating, setIsRotating] = useState(false);
   const [data, setData] = useState([]);
   const dispatch = useDispatch();
   const { isOpen, onOpen, onClose } = useDisclosure();
   const { isOpen: isOpenLog, onOpen: onOpenLog, onClose: onCloseLog } = useDisclosure();
   const [logId, setLogId] = useState(null);
   const [showExtraButtons, setShowExtraButtons] = useState(false);
   const [transactionType, setTransactionType] = useState('');
   const isBankPageTrue = true;
   const [searchQuery, setSearchQuery] = useState('');
   const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
   const [sorting, setSorting] = useState([]);
   const [isEditMode, setIsEditMode] = useState(false);

   // Loading states for different operations
   const [isDataLoading, setIsDataLoading] = useState(false);
   const [isSearching, setIsSearching] = useState(false);
   const [isFiltering, setIsFiltering] = useState(false);
   const [isInitialLoad, setIsInitialLoad] = useState(true);
   const [isSorting, setIsSorting] = useState(false);
   const [isApiCallInProgress, setIsApiCallInProgress] = useState(false);
   const [isModalLoading, setIsModalLoading] = useState(false);
   const [isColumnModalOpen, setIsColumnModalOpen] = useState(false);
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
   const [selectedRowId, setSelectedRowId] = React.useState(null);
   const [receivedAmount, setReceivedAmount] = useState(0);
   const [isOutstandingModalOpen, setIsOutstandingModalOpen] = useState(false);
   const [updateFormLoading, setUpdateFormLoading] = useState(false);
   const [checkedItems, setCheckedItems] = useState([]);
   const [editingValues, setEditingValues] = useState({});
   const daybookTypeData = useSelector((state) => state.daybook?.listPayment || []);
   const lastVoucherDaybookData = useSelector((state) => state.voucher?.lastVoucherDaybook || null);
   const lastNewVoucherData = useSelector((state) => state.voucher?.lastVoucher || null);
   const [selectedAccount, setSelectedAccount] = useState(null);
   const [selectedEditAccount, setSelectedEditAccount] = useState(null);
   const [isOpenSingleView, setIsOpenSingleView] = React.useState(false);
   const [previousTxnType, setPreviousTxnType] = useState(transactionType === 'payment' ? 1 : 0);
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');

   const [formData, setFormData] = useState({
      companyId: parseInt(localStorage.getItem('companyId')),
      daybookId: null,
      docNumber: 0,
      txnType: `${transactionType === 'payment' ? 1 : 0}`,
      txnDate: new Date().toISOString().split('T')[0],
      chequeDate: new Date().toISOString().split('T')[0],
      accountId: null,
      amount: receivedAmount,
      brokerId: null,
      supplierId: null,
      chequeNo: null,
      transactionNo: '',
      bankId: null,
      bankBranchId: null,
      particulars: null,
      depositeDate: null,
      clearingDate: null,
      tdsApplicable: false,
      tdsAccountId: null,
      tdsLimit: 0,
      tdsRate: 0,
      tdsCess: 0,
      tdsSurcharge: 0,
      tdsAmount: 0,
      tdsCessAmount: 0,
      tdsSurchargeAmount: 0,
      tdsHCessAmount: 0,
      tdsInterestAmount: 0,
      tdsPenaltyAmount: 0,
      tdsOthersAmount: 0,
      notes1: '',
      notes2: '',
      notes3: '',
      notes4: '',
      notes5: '',
      userNote: '',
      taxableValue: '',
      GSTAmount: 0,
      stateOfSupply: 0,
      isRCM: false,
      GSTSubTxnType: 0,
      HSNSACId: null,
      typeofSupply: 0,
      partyBillNo: 0,
      GSTTxnType: 0,
      chequeDate: new Date().toISOString().split('T')[0],
      outAdjustments: [],
   });

   const [isAddingNew, setIsAddingNew] = useState(false);
   const isMobileOrTablet = useBreakpointValue({ base: true, md: false, lg: false });
   const Admin = user?.isAdmin;
   const bankReceiveRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.bankReceive
      : null;

   const bankPaymentRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.bankPayment
      : null;

   const { userGlobalSettingsData } = useGlobal();
   const shouldSendCompanyIdDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendCompanyIdAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const shouldSendCompanyIdItem = userGlobalSettingsData?.[0]?.askCompany?.item || false;
   const globalSetting = userGlobalSettingsData?.[0]?.askCompany?.account;
   const shouldShowCompanyDropdown = globalSetting || false;
   const shouldSendIdInDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;

   const [newRowData, setNewRowData] = useState({
      txnDate: new Date().toISOString().split('T')[0],
      docNumber: 0,
      accountId: '',
      accountName: '',
      amount: '',
      daybookId: daybookTypeData?.length === 1 ? daybookTypeData[0]?.id : null,
      daybookName: '',
      transactionNo: null,
      outstandingAdjustments: '',
      status: true,
   });

   // Filter states
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const [pendingVoucher, setPendingVoucher] = useState([]);
   const [currentPage, setCurrentPage] = useState(1);
   const [limit, setLimit] = useState(10);
   const [filters, setFilters] = useState({
      daybookId: '',
      accountId: '',
      docNumber: '',
      dateFrom: '',
      dateTo: '',
      txnType: '',
   });

   const [errors, setErrors] = useState({});

   // Yup Validation Schema
   const validationSchema = Yup.object().shape({
      daybookId: Yup.number().required('Daybook is required'),
      accountId: Yup.number()
         .typeError('Account must be a valid')
         .required('Account is required')
         .min(1, 'Account must be greater than 0'),
      amount: Yup.number().required('Amount is required').min(0, 'Amount cannot be negative'),
      docNumber: Yup.string().required('Document number is required'),
      txnDate: Yup.date().required('Transaction date is required').typeError('Invalid transaction date'),
      txnType: Yup.number().required('Transaction type is required'),
   });

   const DEFAULT_BANK_COLUMNS = {
      txnDate: true,
      docNumber: true,
      accountName: true,
      amount: true,
      daybookName: true,
      chequeNo: false,
      chequeDate: false,
      status: true,
   };

   const [columnVisibility, setColumnVisibility] = useState(() => {
      const mergeWithDefaults = (existingVisibility) => {
         return {
            ...DEFAULT_BANK_COLUMNS,
            ...existingVisibility,
         };
      };

      if (user?.viewJson?.length) {
         const companySettings = user.viewJson.find((item) => item.companyId === companyId);
         if (companySettings?.bank) {
            return mergeWithDefaults(companySettings.bank);
         }
      }

      return DEFAULT_BANK_COLUMNS;
   });

   // Debounce search query
   useEffect(() => {
      const timer = setTimeout(() => {
         setDebouncedSearchQuery(searchQuery);
      }, 300);
      return () => clearTimeout(timer);
   }, [searchQuery]);

   useEffect(() => {
      setCurrentPage(1);
   }, [searchQuery, filters]);

   // Enhanced handleApplyFilters with proper loading state
   const handleApplyFilters = (newFilters) => {
      setIsFiltering(true);
      setFilters(newFilters);
      setCurrentPage(1);
   };

   // Function to handle API call with loading states
   const fetchBankVoucherData = async () => {
      if (companyId === 'undefined' || isNaN(companyId)) return;

      try {
         setIsApiCallInProgress(true);

         await dispatch(
            getBankVoucher({
               type: DAYBOOK_TYPE.BANK,
               page: currentPage,
               companyId: companyId,
               search: debouncedSearchQuery,
               sortBy: sorting.length ? sorting[0]?.id : 'id',
               sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'desc',
               daybookIds: filters.daybookId && filters.daybookId.length > 0 ? filters.daybookId.join(',') : undefined,
               accountIds: filters.accountId && filters.accountId.length > 0 ? filters.accountId.join(',') : undefined,
               docNumber: filters.docNumber || undefined,
               fromDate: filters.fromDate || undefined,
               toDate: filters.toDate || undefined,
               txnType: filters.txnType !== '' ? filters.txnType : undefined,
            }),
         );
      } catch (error) {
         console.error('Error fetching bank voucher data:', error);
         toast.error('Failed to load data');
      } finally {
         setIsApiCallInProgress(false);
         setIsInitialLoad(false);
         setIsSearching(false);
         setIsFiltering(false);
         setIsSorting(false);
         setIsDataLoading(false);
      }
   };

   // Main data fetching with proper loading states
   useEffect(() => {
      fetchBankVoucherData();
   }, [
      dispatch,
      currentPage,
      limit,
      companyId,
      debouncedSearchQuery,
      sorting,
      filters.daybookId,
      filters.accountId,
      filters.fromDat,
      filters.docNumber,
      filters.toDate,
      filters.txnType,
      pagination?.totalProducts,
   ]);

   // Effect to handle search loading state
   useEffect(() => {
      if (debouncedSearchQuery !== '') {
         setIsSearching(true);
      }
   }, [debouncedSearchQuery]);

   // Effect to handle sorting loading state
   useEffect(() => {
      if (sorting.length > 0) {
         setIsSorting(true);
      }
   }, [sorting]);

   useEffect(() => {
      const userCompanyId = Number(user?.loginhistory?.companyId);
      const localCompanyId = Number(localStorage.getItem('companyId'));

      const validCompanyId =
         !isNaN(userCompanyId) && userCompanyId > 0
            ? userCompanyId
            : !isNaN(localCompanyId) && localCompanyId > 0
               ? localCompanyId
               : null;

      if (!validCompanyId) {
         console.warn('Skipping dispatch: Invalid companyId (NaN)');
         return;
      }

      dispatch(
         getAccountForCashBank({
            compId: validCompanyId,
            status: true,
            ...(shouldShowCompanyDropdown && { companyIds: validCompanyId }),
         }),
      );
      dispatch(
         getDaybookForPayments({
            type: DAYBOOK_TYPE.BANK,
            companyId: validCompanyId,
            ...(shouldSendIdInDaybook && { companyIds: validCompanyId }),
         }),
      );
   }, [dispatch, user?.loginhistory?.companyId, companyId, lastVoucherDaybookData?.daybookId]);

   // Set data from voucher
   useEffect(() => {
      setData(voucher || []);
   }, [voucher]);

   useEffect(() => {
      if (lastNewVoucherData) {
         const lastDocNumber = parseInt(lastNewVoucherData?.docNumber);
         const newDocNumber = isNaN(lastDocNumber) ? 1 : lastDocNumber + 1;

         setNewRowData((prev) => ({
            ...prev,
            docNumber: newDocNumber,
         }));
      }
   }, [lastNewVoucherData]);

   useEffect(() => {
      const method = searchParams.get('method');
      const txn = searchParams.get('txn');
      const accIdRaw = searchParams.get('accId');
      const accId = accIdRaw ? parseInt(accIdRaw, 10) : null;

      if (method === 'bank' && txn === 'receive' && userData.length > 0 && accId) {
         onOpen();
         const matchedAccount = userData.find((acc) => acc.id === accId);
         if (matchedAccount) {
            setSelectedAccount(matchedAccount);
         }
         setTransactionType('receive');
         setFormData((prev) => ({
            ...prev,
            txnType: 0,
            accountId: parseInt(accId),
         }));
      }

      if (method === 'bank' && txn === 'payment' && userData.length > 0 && accId) {
         onOpen();
         const matchedAccount = userData.find((acc) => acc.id === accId);
         if (matchedAccount) {
            setSelectedAccount(matchedAccount);
         }
         setTransactionType('payment');
         setFormData((prev) => ({
            ...prev,
            txnType: 1,
            accountId: parseInt(accId),
         }));
      }
   }, [searchParams, onOpen, transactionType]);

   useEffect(() => {
      const handleKeyDown = (event) => {
         const isInputElement =
            ['INPUT', 'TEXTAREA'].includes(event.target.tagName) || event.target.contentEditable === 'true';

         if (!isInputElement) {
            // '+' or 'Shift + =' for Receive
            if ((event.key === '+' || (event.key === '=' && event.shiftKey)) && user && !user.isExpired) {
               event.preventDefault();
               if (Admin || bankReceiveRight?.add) {
                  setTransactionType('receive');
                  onOpen();
               }
            }

            // '-' for Payment
            if (event.key === '-' && user && !user.isExpired) {
               event.preventDefault();
               if (Admin || bankPaymentRight?.add) {
                  setTransactionType('payment');
                  onOpen();
               }
            }
         }
      };

      document.addEventListener('keydown', handleKeyDown);
      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, [onOpen, setTransactionType, bankPaymentRight?.add, bankReceiveRight?.add, Admin, user]);

   // Enhanced shouldShowLoader calculation
   const shouldShowLoader = useMemo(() => {
      return isApiCallInProgress || isInitialLoad || isSearching || isFiltering || isSorting || isDataLoading;
   }, [isApiCallInProgress, isInitialLoad, isSearching, isFiltering, isSorting, isDataLoading]);

   // Get appropriate loading message
   const getLoadingMessage = () => {
      if (isFiltering) return 'Applying Filters...';
      if (isSearching) return 'Searching Bank Entries...';
      if (isSorting) return 'Sorting Data...';
      if (isInitialLoad) return 'Loading Bank Entries...';
      return 'Loading Data...';
   };

   // startEditing function
   const startEditing = async (id, rowData) => {
      try {
         setIsModalLoading(true);
         setUpdateFormLoading(true);
         setEditingId(id);

         setEditingData({});
         setErrors({});
         setPendingVoucher([]);

         const response = await dispatch(getOneVoucher(id));
         const voucherData = rowData || response?.data || singleEntity;

         if (!voucherData) {
            throw new Error('No voucher data received');
         }

         const txnType = voucherData.txnType;
         const transType = txnType === 0 ? 'receive' : 'payment';
         setTransactionType(transType);

         if (voucherData.accountId && userData?.length > 0) {
            const matchedAccount = userData.find((acc) => acc.id === voucherData.accountId);
            if (matchedAccount) {
               setSelectedEditAccount(matchedAccount);
            }
         }

         const completeFormData = {
            id: id,
            companyId: voucherData.companyId || parseInt(localStorage.getItem('companyId')),
            daybookId: voucherData.daybookId,
            docNumber: voucherData.docNumber,
            txnType: txnType,
            txnDate: voucherData.txnDate
               ? moment(voucherData.txnDate).format('YYYY-MM-DD')
               : new Date().toISOString().split('T')[0],
            accountId: voucherData.accountId,
            amount: voucherData.amount || 0,
            brokerId: voucherData.brokerId,
            supplierId: voucherData.supplierId,
            chequeNo: Number(voucherData.chequeNo) || 0,
            transactionNo: voucherData.transactionNo,
            bankId: voucherData.bankId,
            bankBranchId: voucherData.bankBranchId,
            particulars: voucherData.particulars || '',
            depositeDate: voucherData.depositeDate ? moment(voucherData.depositeDate).format('YYYY-MM-DD') : null,
            clearingDate: voucherData.clearingDate ? moment(voucherData.clearingDate).format('YYYY-MM-DD') : null,
            chequeDate: voucherData.chequeDate
               ? moment(voucherData.chequeDate).format('YYYY-MM-DD')
               : new Date().toISOString().split('T')[0],
            tdsApplicable: voucherData.tdsApplicable || false,
            tdsAccountId: voucherData.tdsAccountId,
            tdsLimit: voucherData.tdsLimit || 0,
            tdsRate: voucherData.tdsRate || 0,
            tdsCess: voucherData.tdsCess || 0,
            tdsSurcharge: voucherData.tdsSurcharge || 0,
            tdsAmount: voucherData.tdsAmount || 0,
            tdsCessAmount: voucherData.tdsCessAmount || 0,
            tdsSurchargeAmount: voucherData.tdsSurchargeAmount || 0,
            tdsHCessAmount: voucherData.tdsHCessAmount || 0,
            tdsInterestAmount: voucherData.tdsInterestAmount || 0,
            tdsPenaltyAmount: voucherData.tdsPenaltyAmount || 0,
            tdsOthersAmount: voucherData.tdsOthersAmount || 0,
            notes1: voucherData.notes1 || '',
            notes2: voucherData.notes2 || '',
            notes3: voucherData.notes3 || '',
            notes4: voucherData.notes4 || '',
            notes5: voucherData.notes5 || '',
            userNote: voucherData.userNote || '',
            taxableValue: voucherData.taxableValue || '',
            GSTAmount: voucherData.GSTAmount || 0,
            stateOfSupply: voucherData.stateOfSupply || 0,
            isRCM: voucherData.isRCM || false,
            GSTSubTxnType: voucherData.GSTSubTxnType || 0,
            HSNSACId: voucherData.HSNSACId,
            typeofSupply: voucherData.typeofSupply || 0,
            partyBillNo: voucherData.partyBillNo || 0,
            GSTTxnType: voucherData.GSTTxnType || 0,
            outAdjustments: voucherData.outAdjustments || [],
         };

         setFormData(completeFormData);
         setReceivedAmount(voucherData.amount || 0);

         if (voucherData.pendingVoucher) {
            setPendingVoucher(voucherData.pendingVoucher);
         }

         setIsOutstandingModalOpen(true);
      } catch (error) {
         console.error('❌ Error in startEditing:', error);
         toast.error('Error loading voucher data: ' + error.message);
         setUpdateFormLoading(false);
         setIsOutstandingModalOpen(false);
         setEditingId(null);
      }
   };

   // handleDelete function
   const handleDelete = async () => {
      if (selectedRowId !== null) {
         try {
            setIsDataLoading(true);
            const res = await dispatch(deleteVoucher(selectedRowId));
            // Refresh the data after deletion
            dispatch(
               getBankVoucher({
                  type: DAYBOOK_TYPE.BANK,
                  page: currentPage,
                  companyId: companyId,
                  search: debouncedSearchQuery,
                  sortBy: sorting.length ? sorting[0]?.id : 'id',
                  sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'desc',
               }),
            );
            setDeleteDialogOpen(false);
            toast.success('Record deleted successfully');
            if (companyId && res && res?.code === 1) {
               dispatch(
                  getDaybook({
                     companyId: Number(companyId),
                     ...(shouldSendCompanyIdDaybook && { companyIds: companyId }),
                  }),
               );
               dispatch(
                  getDaybookForPayments({
                     type: DAYBOOK_TYPE.BANK,
                     companyId: Number(companyId),
                     ...(shouldSendCompanyIdDaybook && { companyIds: companyId }),
                  }),
               );
               dispatch(
                  getItem({
                     companyId: companyId,
                     sortBy: 'name',
                     sortOrder: 'asc',
                     ...(shouldSendCompanyIdItem && { companyIds: companyId }),
                  }),
               );
               dispatch(
                  getAccount({
                     compId: Number(companyId),
                     accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
                     status: true,
                     ...(shouldSendCompanyIdAccount && { companyIds: companyId }),
                  }),
               );
               dispatch(
                  getAccountForCashBank({
                     compId: Number(companyId),
                     status: true,
                     ...(shouldSendCompanyIdAccount && { companyIds: companyId }),
                  }),
               );
            }
         } catch (err) {
            console.error('Failed to delete voucher:', err);
            toast.error('Failed to delete record');
         } finally {
            setIsDataLoading(false);
         }
      }
   };

   const handleMultiDeleteClick = async (ids) => {
      if (!ids || ids.length === 0) {
         toast.error('Please select records to delete');
         return;
      }

      try {
         setIsDataLoading(true);

         // Prepare the data in the required format: { voucherIds: [244, 448, 278, 2815] }
         const deleteData = {
            voucherIds: ids,
            companyId: companyId,
         };

         console.log('deleteData', deleteData);

         // Call the multiDeleteVoucher API directly
         await dispatch(multiDeleteVoucher(deleteData));

         // The reducer will automatically update the list, but we can refresh to be safe
         dispatch(
            getBankVoucher({
               type: DAYBOOK_TYPE.BANK,
               page: currentPage,
               companyId: companyId,
               search: debouncedSearchQuery,
               sortBy: sorting.length ? sorting[0]?.id : 'id',
               sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'desc',
            }),
         );

         // Success message is shown from the action itself

         // Refresh related data
         if (companyId) {
            dispatch(
               getDaybook({
                  companyId: Number(companyId),
                  ...(shouldSendCompanyIdDaybook && { companyIds: companyId }),
               }),
            );
            dispatch(
               getItem({
                  companyId: companyId,
                  sortBy: 'name',
                  sortOrder: 'asc',
                  ...(shouldSendCompanyIdItem && { companyIds: companyId }),
               }),
            );
            dispatch(
               getAccount({
                  compId: Number(companyId),
                  accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
                  status: true,
                  ...(shouldSendCompanyIdAccount && { companyIds: companyId }),
               }),
            );
         }
      } catch (err) {
         console.error('Failed to delete vouchers:', err);
         // Error message is shown from the action itself
      } finally {
         setIsDataLoading(false);
      }
   };

   const handleDeleteClick = (id) => {
      setSelectedRowId(id);
      setDeleteDialogOpen(true);
   };

   const handleViewSingleData = async (id) => {
      setIsModalLoading(true); // Add this
      setIsOpenSingleView(true); // Add this to open modal immediately

      try {
         await dispatch(getOneVoucher(id));
         setIsOpenSingleView(true);
      } catch (error) {
         console.error('❌ Error loading voucher for view:', error);
         toast.error('Error loading voucher data');
         setIsOpenSingleView(false); // Close on error
      } finally {
         setIsModalLoading(false); // Always turn off loading
      }
   };

   // handleClearData function
   const handleClearData = () => {
      setPendingVoucher([]);
      setEditingId(null);
      setEditingData({});
      setUpdateFormLoading(false);
      setIsOutstandingModalOpen(false);
      setFormData({
         companyId: parseInt(localStorage.getItem('companyId')),
         daybookId: daybookTypeData?.length === 1 ? daybookTypeData[0].id : null,
         docNumber: 0,
         txnType: `${transactionType === 'payment' ? 1 : 0}`,
         txnDate: new Date().toISOString().split('T')[0],
         accountId: null,
         amount: receivedAmount ? receivedAmount : 0,
         brokerId: null,
         supplierId: null,
         chequeNo: 0,
         transactionNo: null,
         bankId: null,
         bankBranchId: null,
         particulars: '',
         depositeDate: null,
         clearingDate: null,
         tdsApplicable: false,
         tdsAccountId: null,
         tdsLimit: 0,
         tdsRate: 0,
         tdsCess: 0,
         tdsSurcharge: 0,
         tdsAmount: 0,
         tdsCessAmount: 0,
         tdsSurchargeAmount: 0,
         tdsHCessAmount: 0,
         tdsInterestAmount: 0,
         tdsPenaltyAmount: 0,
         tdsOthersAmount: 0,
         notes1: '',
         notes2: '',
         notes3: '',
         notes4: '',
         notes5: '',
         userNote: '',
         taxableValue: '',
         GSTAmount: 0,
         stateOfSupply: 0,
         isRCM: false,
         GSTSubTxnType: 0,
         HSNSACId: null,
         typeofSupply: 0,
         partyBillNo: 0,
         GSTTxnType: 0,
         chequeDate: new Date().toISOString().split('T')[0],
         outAdjustments: [],
      });
      setCheckedItems([]);
      setReceivedAmount(0);
      setEditingValues({});
      setSelectedAccount(null);
      setSelectedEditAccount(null);
      setTotalPendingAccount(0);
      setErrors({});
      dispatch(clearPendingVoucher());
   };

   const handleLogShow = (data) => {
      setLogId(data.id);
      console.log(setLogId);
      onOpenLog();
   };

   const columnHelper = createColumnHelper();
   // Define columns data for DynamicTable
   const columnsData = useMemo(
      () => [
         {
            id: 'txnDate',
            header: 'Date',
            accessorKey: 'txnDate',
            show: columnVisibility.txnDate,
            cell: (info) => moment(info.getValue()).format('DD-MM-YYYY'),
         },
         {
            id: 'docNumber',
            header: 'Doc Number',
            accessorKey: 'docNumber',
            show: columnVisibility.docNumber,
         },
         {
            id: 'accountName',
            header: 'Account',
            accessorKey: 'accountName',
            show: columnVisibility.accountName,
         },
         {
            id: 'amount',
            header: 'Amount',
            accessorKey: 'amount',
            show: columnVisibility.amount,
            cell: (info) => {
               const row = info.row.original;
               const value = info.getValue();
               const label = row.txnType === 1 ? 'CR' : 'DB';
               return (
                  <Badge
                     border="1px solid"
                     bg="transparent"
                     borderColor={row.txnType === 1 ? 'red' : 'green'}
                     color={row.txnType === 1 ? 'red' : 'green'}
                     borderRadius="md"
                     w="100%"
                     justifyContent="center"
                     alignItems="center"
                     display="inline-flex"
                     textTransform="capitalize">
                     {formatAmountWithLabel(value)}&nbsp;{label}
                  </Badge>
               );
            },
         },
         {
            id: 'daybookName',
            header: 'Daybook',
            accessorKey: 'daybookName',
            show: columnVisibility.daybookName,
            cell: (info) => info.getValue() || '-',
         },
         {
            id: 'chequeNo',
            header: 'Cheque No',
            accessorKey: 'chequeNo',
            show: columnVisibility.chequeNo,
            cell: (info) => info.getValue() || '-',
         },
         {
            id: 'chequeDate',
            header: 'Cheque Date',
            accessorKey: 'chequeDate',
            show: columnVisibility.daybookName,
            cell: (info) => info.getValue() || '-',
         },
         {
            id: 'status',
            header: 'Status',
            accessorKey: 'status',
            show: columnVisibility.status,
            cell: (info) => (info.getValue() ? 'Active' : 'Inactive'),
         },
      ],
      [columnVisibility],
   );

   const columns = useMemo(() => {
      const baseColumns = [
         columnHelper.accessor('txnDate', {
            id: 'txnDate',
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  Date
               </Text>
            ),
            cell: (info) => <Flex align="center">{moment(info.getValue()).format('DD-MM-YYYY')}</Flex>,
         }),
         columnHelper.accessor('docNumber', {
            id: 'docNumber',
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  Doc Number
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
         columnHelper.accessor('accountName', {
            id: 'accountName',
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  Account
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
         columnHelper.accessor('amount', {
            id: 'amount',
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  Amount
               </Text>
            ),
            cell: (info) => {
               const row = info.row.original;
               const value = info.getValue();
               const label = row.txnType === 1 ? 'CR' : 'DB';
               return (
                  <Flex align="center">
                     <Badge
                        border="1px solid"
                        bg="transparent"
                        borderColor={row.txnType === 1 ? 'red' : 'green'}
                        color={row.txnType === 1 ? 'red' : 'green'}
                        borderRadius="md"
                        w="100%"
                        justifyContent="center"
                        alignItems="center"
                        display="inline-flex"
                        textTransform="capitalize">
                        {formatAmountWithLabel(value)}&nbsp;{label}
                     </Badge>
                  </Flex>
               );
            },
         }),
         columnHelper.accessor('daybookName', {
            id: 'daybookName',
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  Daybook
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue() || '-'}</Flex>,
         }),
         columnHelper.accessor('status', {
            id: 'status',
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  Status
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue() ? 'Active' : 'Inactive'}</Flex>,
         }),
      ];

      // Filter columns based on visibility
      return baseColumns.filter((column) => columnVisibility[column.id]);
   }, [columnHelper, columnVisibility]);

   const table = useReactTable({
      data: data,
      columns,
      state: {
         sorting,
         columnVisibility,
      },
      onSortingChange: setSorting,
      onColumnVisibilityChange: setColumnVisibility,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', 'rgba(12, 20, 41, 1)');
   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();

   useEffect(() => {
      localStorage.setItem('bankColumnVisibility', JSON.stringify(columnVisibility));
   }, [columnVisibility]);

   const ColumnVisibilityModal = ({ isOpen, onClose, columnVisibility, setColumnVisibility, user }) => {
      const [localVisibility, setLocalVisibility] = useState(columnVisibility);
      const dispatch = useDispatch();
      const companyId = Number(localStorage.getItem('companyId'));

      // Get theme mode
      const { colorMode } = useColorMode();
      const isDark = colorMode === 'dark';

      useEffect(() => {
         const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
               onClose();
               window.dispatchEvent(new Event('GLOBAL_ESC'));
            }
         };

         window.addEventListener('keydown', handleKeyDown, true);
         return () => {
            window.removeEventListener('keydown', handleKeyDown, true);
         };
      }, [onClose]);

      useEffect(() => {
         if (isOpen) {
            setLocalVisibility(columnVisibility);
         }
      }, [isOpen, columnVisibility]);

      const handleSave = async () => {
         try {
            localStorage.setItem('bankColumnVisibility', JSON.stringify(localVisibility));

            if (user?.viewJson) {
               const updatedViewJson = user.viewJson.map((item) =>
                  item.companyId === companyId ? { ...item, bank: localVisibility } : item,
               );

               await dispatch(
                  postColumnsHideShow({
                     userId: user?.id,
                     viewJson: updatedViewJson,
                  }),
               );
            }

            setColumnVisibility(localVisibility);
            toast.success('Column settings saved successfully');
            onClose();
         } catch (error) {
            toast.error('Failed to save column settings');
         }
      };

      // Conditional render check
      if (!isOpen) return null;

      return (
         <div className="fixed inset-0 z-[999] flex items-center justify-center p-4">
            {/* Overlay with blur */}
            <div
               className={`absolute inset-0 transition-colors duration-300 ${isDark ? 'bg-black/70' : 'bg-black/40'}`}
               onClick={onClose}
            />

            {/* Modal Content */}
            <div
               className={`relative w-full max-w-2xl transform transition-all duration-300 ${isDark
                  ? 'bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900'
                  : 'bg-gradient-to-br from-white via-gray-50 to-white'
                  } rounded-2xl shadow-2xl border ${isDark ? 'border-slate-700/50' : 'border-gray-200/50'
                  } overflow-hidden flex flex-col max-h-[80vh]`}>
               {/* Header - Fixed */}
               <div
                  className={`relative px-8 py-6 border-b flex-shrink-0 ${isDark
                     ? 'border-slate-700/50 bg-gradient-to-r from-slate-800/50 to-slate-900/50'
                     : 'border-gray-200/50 bg-gradient-to-r from-gray-50/50 to-white/50'
                     }`}>
                  <h2 className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>Show/Hide Columns</h2>
                  <p className={`mt-1 text-sm ${isDark ? 'text-slate-400' : 'text-gray-600'}`}>
                     Customize which columns appear in your bank table
                  </p>
                  <button
                     onClick={onClose}
                     className={`absolute top-6 right-6 p-2 rounded-lg transition-all duration-200 ${isDark
                        ? 'hover:bg-slate-700/50 text-slate-400 hover:text-white'
                        : 'hover:bg-gray-100 text-gray-500 hover:text-gray-900'
                        }`}>
                     <X className="w-5 h-5" />
                  </button>
               </div>

               {/* Body - Scrollable */}
               <div className="flex-1 overflow-y-auto px-8 py-6">
                  <div className="grid grid-cols-2 gap-4">
                     {Object.entries(localVisibility).map(([key, value]) => (
                        <div
                           key={key}
                           className={`group relative p-5 rounded-xl transition-all duration-300 border-2 ${value
                              ? isDark
                                 ? 'bg-gradient-to-br from-blue-900/20 to-indigo-900/20 border-blue-500/50 shadow-lg shadow-blue-500/10'
                                 : 'bg-gradient-to-br from-blue-50/50 to-indigo-50/50 border-blue-400/50 shadow-lg shadow-blue-200/30'
                              : isDark
                                 ? 'bg-slate-800/30 border-slate-700/30 hover:border-slate-600/50'
                                 : 'bg-white/50 border-gray-300/30 hover:border-gray-400/50'
                              } cursor-pointer hover:scale-[1.02]`}
                           onClick={() => setLocalVisibility((prev) => ({ ...prev, [key]: !prev[key] }))}>
                           {/* Toggle Switch */}
                           <div className="flex items-center justify-between">
                              <label
                                 className={`font-semibold text-base cursor-pointer transition-colors duration-200 ${isDark ? 'text-white' : 'text-gray-900'
                                    }`}>
                                 {key.split(/(?=[A-Z])/).join(' ')}
                              </label>

                              <div
                                 className={`relative inline-flex h-7 w-12 items-center rounded-full transition-all duration-300 ${value
                                    ? isDark
                                       ? 'bg-gradient-to-r from-blue-600 to-indigo-600 shadow-lg shadow-blue-500/30'
                                       : 'bg-gradient-to-r from-blue-500 to-indigo-500 shadow-lg shadow-blue-400/30'
                                    : isDark
                                       ? 'bg-slate-700'
                                       : 'bg-gray-300'
                                    }`}>
                                 <span
                                    className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform duration-300 shadow-md ${value ? 'translate-x-6' : 'translate-x-1'
                                       }`}
                                 />
                              </div>
                           </div>

                           {/* Status indicator */}
                           <div
                              className={`mt-3 flex items-center gap-2 text-xs font-medium ${value
                                 ? isDark
                                    ? 'text-blue-400'
                                    : 'text-blue-600'
                                 : isDark
                                    ? 'text-slate-500'
                                    : 'text-gray-500'
                                 }`}>
                              <div
                                 className={`h-1.5 w-1.5 rounded-full ${value
                                    ? isDark
                                       ? 'bg-blue-400 shadow-lg shadow-blue-400/50'
                                       : 'bg-blue-500 shadow-lg shadow-blue-400/50'
                                    : isDark
                                       ? 'bg-slate-600'
                                       : 'bg-gray-400'
                                    }`}
                              />
                              {value ? 'Visible' : 'Hidden'}
                           </div>
                        </div>
                     ))}
                  </div>
               </div>

               {/* Footer - Fixed */}
               <div
                  className={`px-8 py-5 border-t flex justify-end gap-3 flex-shrink-0 ${isDark
                     ? 'border-slate-700/50 bg-gradient-to-r from-slate-800/50 to-slate-900/50'
                     : 'border-gray-200/50 bg-gradient-to-r from-gray-50/50 to-white/50'
                     }`}>
                  <button
                     onClick={onClose}
                     className={`px-6 py-2.5 rounded-lg font-semibold transition-all duration-200 ${isDark
                        ? 'text-slate-300 hover:bg-slate-700/50 hover:text-white'
                        : 'text-gray-700 hover:bg-gray-200 hover:text-gray-900'
                        }`}>
                     Cancel
                  </button>
                  <button
                     onClick={handleSave}
                     className={`px-6 py-2.5 rounded-lg font-semibold transition-all duration-200 shadow-lg ${isDark
                        ? 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white shadow-blue-500/30'
                        : 'bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white shadow-blue-400/30'
                        }`}>
                     Save
                  </button>
               </div>
            </div>
         </div>
      );
   };

   useEffect(() => {
      if (user && !user?.packageData?.[0]?.bank) {
         window.history.back();
      }
   }, [user]);

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' ||
            activeElement?.isContentEditable;

         if (isTyping) return;

         if (e.key.toLowerCase() === 'r' || e.key === '+') {
            if (
               !isOpen &&
               !isOpenSingleView &&
               !isOpenLog &&
               (Admin || bankReceiveRight?.add) &&
               user &&
               !user.isExpired
            ) {
               setTransactionType('receive');
               setReceivedAmount(0);
               onOpen();
            }
         }
         if (e.key.toLowerCase() === 'p' || e.key === '-') {
            if (
               !isOpen &&
               !isOpenSingleView &&
               !isOpenLog &&
               (Admin || bankPaymentRight?.add) &&
               user &&
               !user.isExpired
            ) {
               setTransactionType('payment');
               setReceivedAmount(0);
               onOpen();
            }
         }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [!isOpen, !isOpenSingleView, isOpenLog, Admin, bankReceiveRight?.add, bankPaymentRight?.add]);

   const handleRefreshData = async () => {
      setIsRotating(!isRotating);
      fetchBankVoucherData();
      if (user?.loginhistory?.companyId) {
         dispatch(
            getDaybook({
               companyId: Number(user?.loginhistory?.companyId),
               ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
         dispatch(
            getDaybookForPayments({
               type: DAYBOOK_TYPE.BANK,
               companyId: Number(user?.loginhistory?.companyId),
               ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
         dispatch(
            getAccount({
               compId: Number(user?.loginhistory?.companyId),
               accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
               status: true,
               ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
         dispatch(
            getAccountForCashBank({
               compId: Number(user?.loginhistory?.companyId),
               status: true,
               ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
   };
   const [isImportModalOpen, setIsImportModalOpen] = useState(false);
   const [excelFile, setExcelFile] = useState(null);
   const [accountShow, setAccountShow] = useState(false);
   const [importAccountId, setImportAccountId] = useState('');
   const [importDaybookId, setImportDaybookId] = useState('');

   const handleExcelUpload = (file) => {
      setExcelFile(file);
   };

   const handleImportExcel = async () => {
      console.log('excelFile', excelFile);
      if (!excelFile) {
         toast({
            title: 'Please select an Excel file',
            status: 'warning',
            position: 'top',
         });
         return;
      }

      if (!importDaybookId) {
         toast({
            title: 'Please select any Daybook',
            status: 'warning',
            position: 'top',
         });
         return;
      }

      try {
         const formData = new FormData();
         formData.append('companyId', user?.loginhistory?.companyId);
         formData.append('daybookId', importDaybookId);
         if (importAccountId) {
            formData.append('accountId', importAccountId);
         }
         formData.append('excel', excelFile);

         console.log('formData', formData);
         const res = await dispatch(importVoucherExcel(formData));
         console.log('res for voucher import', res);
         if (res && res.code === 1) {
            setImportDaybookId('');
            setImportAccountId('');
            setAccountShow(false);
            setExcelFile(null);
         }
         setIsImportModalOpen(false);
      } catch (error) {
         console.log('error', error);
         toast({
            title: error?.message || 'Import failed',
            status: 'error',
            position: 'top',
         });
      }
   };

   const handleDownloadDemoExcel = () => {
      const link = document.createElement('a');
      link.href = '/sample/voucher_import_demo.xlsx';
      link.download = 'voucher_import_demo.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
   };

   return (
      <Box className="pt-14">
         <Card
            flexDirection="column"
            w="100%"
            pt={''}
            bg={backgroundColor}
            px="0px"
            overflowX={{ sm: 'scroll', lg: 'hidden' }}>
            <Flex px="15px" mb={1} justifyContent="space-between" align="center" mt={2} overflowX="auto">
               <Flex align="center" gap={4}>
                  <Text color={textColor} fontSize={{ base: '14px', lg: '18px' }} fontWeight="700">
                     Bank Entry
                  </Text>
               </Flex>
               <Flex align="center" gap={2} flexShrink={0} p={3}>
                  {!isMobileOrTablet && (
                     <>
                        {(Admin || bankReceiveRight?.add) && user && !user.isExpired && (
                           <button
                              onClick={() => {
                                 setTransactionType('receive');
                                 setReceivedAmount(0);
                                 onOpen();
                              }}
                              className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${isDark
                                 ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                                 : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                                 }`}>
                              {/* Gradient overlay on hover */}
                              <span
                                 className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${isDark ? 'via-cyan-100/20' : 'via-white/30'
                                    }`}></span>
                              {/* Icon container with background */}
                              <span
                                 className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${isDark
                                    ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30'
                                    : 'bg-white/20 group-hover:bg-white/30'
                                    }`}>
                                 <svg
                                    className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24">
                                    <path
                                       strokeLinecap="round"
                                       strokeLinejoin="round"
                                       strokeWidth="2.5"
                                       d="M12 4v16m8-8H4"
                                    />
                                 </svg>
                              </span>
                              <span className="relative text-base font-semibold">Receive</span>
                           </button>
                        )}
                        {(Admin || bankPaymentRight?.add) && user && !user.isExpired && (
                           <button
                              onClick={() => {
                                 setTransactionType('payment');
                                 setReceivedAmount(0);
                                 onOpen();
                              }}
                              className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${isDark
                                 ? 'bg-gradient-to-br from-red-400 to-pink-500 hover:from-red-300 hover:to-pink-400 text-white shadow-red-500/30 hover:shadow-2xl hover:shadow-red-400/40 focus:ring-red-200/50 border-red-300/30'
                                 : 'bg-gradient-to-br from-red-400 to-rose-500 hover:from-red-300 hover:to-rose-400 text-white shadow-red-500/30 hover:shadow-2xl hover:shadow-red-400/40 focus:ring-red-200/70 border-red-300/50'
                                 }`}>
                              {/* Gradient overlay on hover */}
                              <span
                                 className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${isDark ? 'via-red-100/20' : 'via-white/30'
                                    }`}></span>
                              {/* Icon container with background */}
                              <span
                                 className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${isDark
                                    ? 'bg-red-100/20 group-hover:bg-red-100/30'
                                    : 'bg-white/20 group-hover:bg-white/30'
                                    }`}>
                                 <svg
                                    className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M20 12H4" />
                                 </svg>
                              </span>
                              <span className="relative text-base font-semibold">Payment</span>
                           </button>
                        )}
                     </>
                  )}
                  <Box>
                     <IconButton
                        icon={
                           <Box
                              as={FiRefreshCcw}
                              transform={isRotating ? 'rotate(-360deg)' : 'rotate(0deg)'}
                              transition="transform 1s ease"
                           />
                        }
                        aria-label="Refresh"
                        variant="ghost"
                        size="lg"
                        _hover={{ bg: hoverBg }}
                        isRound
                        onClick={handleRefreshData}
                     />
                  </Box>
                  <Box cursor={'pointer'} onClick={onFilterOpen} mr={3}>
                     <IoFilterOutline size={22} />
                  </Box>
                  <Box cursor={'pointer'} onClick={() => navigate('/admin/bank/managedaybook')}>
                     <AiTwotoneBook size={22} />
                  </Box>
                  <IconButton
                     icon={<BsFileEarmarkExcel />}
                     colorScheme="gray"
                     size="md"
                     mr={1}
                     onClick={() => setIsImportModalOpen(true)}
                     aria-label="Import Excel"
                  />
                  <IconButton
                     colorScheme="gray"
                     icon={<BsEye />}
                     size="md"
                     mr={1}
                     onClick={() => {
                        setIsColumnModalOpen(true);
                     }}
                  />
                  <MotionFlex
                     ref={wrapperRef}
                     align="center"
                     bg={bg}
                     borderRadius="full"
                     // me="20px"
                     cursor="pointer"
                     px={expanded ? 3 : 0}
                     w={expanded ? '200px' : '40px'}
                     h="40px"
                     transition="all 0.3s ease"
                     onClick={() => setExpanded(true)}>
                     <MotionSearchIcon
                        color={icon}
                        animate={{ rotate: expanded ? 0 : 90 }}
                        transition={{ duration: 0.3 }}
                        style={{ marginRight: expanded ? '8px' : '10px', marginLeft: expanded ? '0' : '10px' }}
                     />
                     {expanded && (
                        <Input
                           variant="unstyled"
                           placeholder="Search..."
                           value={searchQuery}
                           color={icon}
                           onChange={(e) => setSearchQuery(e.target.value)}
                           autoFocus
                        />
                     )}
                  </MotionFlex>
                  <Menu
                     onDownloadPDF={downloadPDF}
                     onDownloadExcel={downloadExcel}
                     columnVisibility={columnVisibility}
                     setColumnVisibility={setColumnVisibility}
                  />
               </Flex>
            </Flex>

            <Text display="flex" alignContent="center" justifyContent="center" borderTop="1px solid #ccc">
               {daybookTypeData?.map(
                  (item, i) =>
                     item.bal !== 0 && (
                        <React.Fragment key={i}>
                           <Text as="span" color={item.bal > 0 ? 'red' : 'green'}>
                              {item.name} :{Math.abs(item.bal).toFixed(2).split('.')[0]}.
                              <Text as="span" fontSize="0.8em">
                                 {Math.abs(item.bal).toFixed(2).split('.')[1]}
                              </Text>{' '}
                              {item.bal > 0 ? 'CR' : 'DB'}
                           </Text>
                           {i < daybookTypeData.length - 1 && (
                              <Text as="span" mx="1">
                                 |
                              </Text>
                           )}
                        </React.Fragment>
                     ),
               )}
            </Text>

            {/* Enhanced Loader with dynamic message */}
            <div className="px-4 pb-4">
               {shouldShowLoader ? (
                  <Loader />
               ) : (
                  <DynamicTable
                     right={bankPaymentRight && bankReceiveRight}
                     paymentRight={bankPaymentRight}
                     receiveRight={bankReceiveRight}
                     table={table}
                     data={data}
                     handleViewSingleData={handleViewSingleData}
                     filter={filter}
                     emptyMessage={'No bank entry data found'}
                     setCurrentRow={(row) => {
                        setIsEditMode(true);
                        setIsOpenSingleView(false);
                        startEditing(row.id, row);
                     }}
                     onDeleteClick={(id) => {
                        const selectedData = data.filter((da) => da.id === id);
                        const selectedDaybook = daybookData.filter((dd) => dd.id === selectedData[0].daybookId);
                        if (selectedDaybook.length > 0 && selectedDaybook[0]?.askPasswordOnDelete) {
                           setDataId(id);
                           setIsModalOpen(true);
                        } else {
                           handleDeleteClick(id);
                        }
                        // handleDeleteClick(id);
                        // setIsOpenSingleView(false);
                     }}
                     onMultiDeleteClick={(ids) => {
                        const tempData = data.filter((da) => ids.includes(da.id));
                        let daybookIds = [];
                        tempData?.forEach((item) => {
                           if (item?.daybookId && !daybookIds.includes(item.daybookId)) {
                              daybookIds.push(item.daybookId);
                           }
                        });

                        let requiresPassword = false;
                        daybookIds.forEach((id) => {
                           const selectedDaybook = daybookData.find((dd) => dd.id === id);
                           if (selectedDaybook?.askPasswordOnDelete) {
                              requiresPassword = true;
                           }
                        });

                        if (requiresPassword) {
                           setMultiDeleteData(ids);
                           setMultiPass(true);
                        } else {
                           handleMultiDeleteClick(ids);
                        }
                     }}
                     canDelete={true}
                     columnVisibility={columnVisibility}
                     columnsData={columnsData}
                     sorting={sorting}
                     limit={''}
                     onOpen={() => console.log('')}
                     setIsEditMode={setIsEditMode}
                     setIsOpenSingleView={setIsOpenSingleView}
                     setDeleteDialogOpen={setDeleteDialogOpen}
                     setSelectedRowId={setSelectedRowId}
                     debouncedSearchQuery={debouncedSearchQuery}
                     type={'bank'}
                     onLogClick={handleLogShow}
                  />
               )}
            </div>
         </Card>

         {/* Floating Action Buttons for Mobile */}
         {isMobileOrTablet && (Admin || bankPaymentRight?.add || bankReceiveRight?.add) && (
            <>
               <Button
                  onClick={() => setShowExtraButtons(!showExtraButtons)}
                  width="40px"
                  variant="darkBrand"
                  color="white"
                  fontSize="30px"
                  fontWeight="500"
                  borderRadius="full"
                  position="fixed"
                  bottom="20px"
                  right="38px"
                  p={6}
                  zIndex={100}>
                  {showExtraButtons ? '×' : '+'}
               </Button>

               {showExtraButtons && (
                  <>
                     {/* Show Payment button only if user has bankPaymentRight or is Admin */}
                     {(Admin || bankPaymentRight?.add) && (
                        <Button
                           onClick={() => {
                              setTransactionType('payment');
                              onOpen();
                           }}
                           variant="darkBrand"
                           color="white"
                           fontSize="sm"
                           fontWeight="500"
                           borderRadius="full"
                           position="fixed"
                           bottom="80px"
                           right="10px"
                           p={{ base: '4', lg: '4' }}
                           zIndex={100}>
                           Payment
                        </Button>
                     )}

                     {/* Show Receive button only if user has bankReceiveRight or is Admin */}
                     {(Admin || bankReceiveRight?.add) && (
                        <Button
                           onClick={() => {
                              setTransactionType('receive');
                              onOpen();
                           }}
                           variant="darkBrand"
                           color="white"
                           fontSize="sm"
                           fontWeight="500"
                           borderRadius="full"
                           position="fixed"
                           bottom="140px"
                           right="14px"
                           p={{ base: '4', lg: '4' }}
                           zIndex={100}>
                           Receive
                        </Button>
                     )}
                  </>
               )}
            </>
         )}

         {/* ADD FORM - Only show when NOT editing (no formData.id) */}
         {/* {!formData.id && ( */}
         <PaymentCaseForm
            isOpen={isOpen}
            checkedItems={checkedItems}
            setCheckedItems={setCheckedItems}
            editingValues={editingValues}
            daybookTypeData={daybookTypeData}
            userData={userData}
            totalPendingAccount={totalPendingAccount}
            setTotalPendingAccount={setTotalPendingAccount}
            validationSchema={validationSchema}
            errors={errors}
            setErrors={setErrors}
            isBankPageTrue={isBankPageTrue}
            selectedAccount={selectedAccount}
            setSelectedAccount={setSelectedAccount}
            handleClearData={handleClearData}
            setEditingValues={setEditingValues}
            onClose={() => {
               onClose();
               handleClearData();
            }}
            formData={formData}
            setFormData={setFormData}
            receivedAmount={receivedAmount}
            setReceivedAmount={setReceivedAmount}
            handleSave={async (formData) => {
               try {
                  await validationSchema.validate(formData, { abortEarly: false });
                  setErrors({});
                  delete formData.pendingVoucher;
                  await dispatch(addVoucher(formData));
                  onClose();
                  handleClearData();
                  // Refresh data
                  dispatch(
                     getBankVoucher({
                        type: DAYBOOK_TYPE.BANK,
                        page: currentPage,
                        companyId: companyId,
                        search: debouncedSearchQuery,
                        sortBy: sorting.length ? sorting[0]?.id : 'id',
                        sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'desc',
                     }),
                  );
                  toast.success('Record added successfully');
               } catch (err) {
                  console.error('❌ Error saving voucher:', err);
                  if (err.inner?.length) {
                     const validationErrors = {};
                     err.inner.forEach((e) => {
                        validationErrors[e.path] = e.message;
                     });
                     setErrors(validationErrors);
                     toast.error(err.inner[0].message);
                  } else {
                     toast.error('Error adding record');
                     console.error('Error adding voucher:', err);
                  }
               }
            }}
            selectedOption={'None'}
            transactionType={transactionType}
            handleSelect={() => { }}
            fetchBankVoucherData={() => fetchBankVoucherData()}
         />
         {/* )} */}

         {/* EDIT FORM - Only show when editing (has formData.id and updateFormLoading) */}
         {updateFormLoading && formData.id && (
            <PaymentCaseFormEdit
               isOutstandingModalOpen={isOutstandingModalOpen}
               setIsOutstandingModalOpen={setIsOutstandingModalOpen}
               userData={userData}
               daybookTypeData={daybookTypeData}
               validationSchema={validationSchema}
               errors={errors}
               voucher_prev_next={voucher_prev_next}
               setErrors={setErrors}
               isBankPageTrue={isBankPageTrue}
               pendingVoucher={pendingVoucher}
               setPendingVoucher={setPendingVoucher}
               totalPendingAccount={totalPendingAccount}
               setTotalPendingAccount={setTotalPendingAccount}
               currentPage={currentPage}
               limit={''}
               type={14}
               companyId={companyId}
               searchQuery={debouncedSearchQuery}
               selectedAccount={selectedEditAccount}
               setSelectedAccount={setSelectedEditAccount}
               sorting={sorting}
               pagination={pagination}
               onClose={() => {
                  setUpdateFormLoading(false);
                  setIsOutstandingModalOpen(false);
                  setEditingId(null);
                  setSelectedEditAccount(null);
                  setReceivedAmount(0);
               }}
               formData={formData}
               setFormData={setFormData}
               checkedItems={checkedItems}
               setCheckedItems={setCheckedItems}
               editingValues={editingValues}
               handleClearData={handleClearData}
               setEditingValues={setEditingValues}
               handleSave={async (formData) => {
                  try {
                     // Validate form data
                     try {
                        await validationSchema.validate(formData, { abortEarly: false });
                        setErrors({});
                     } catch (err) {
                        if (err.inner && err.inner.length > 0) {
                           const validationErrors = {};
                           err.inner.forEach((e) => {
                              validationErrors[e.path] = e.message;
                           });
                           setErrors(validationErrors);
                           toast.error(err.inner[0].message);
                        }
                        return;
                     }

                     // Update voucher
                     await dispatch(updateVoucher(formData));

                     // Reset states after successful update
                     setUpdateFormLoading(false);
                     setIsOutstandingModalOpen(false);
                     handleClearData();

                     // Refresh the data
                     if (companyId !== 'undefined' && !isNaN(companyId)) {
                        dispatch(
                           getBankVoucher({
                              type: DAYBOOK_TYPE.BANK,
                              page: currentPage,
                              companyId: companyId,
                              search: debouncedSearchQuery,
                              sortBy: sorting.length ? sorting[0]?.id : 'id',
                              sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'desc',
                              daybookIds:
                                 filters.daybookId && filters.daybookId.length > 0
                                    ? filters.daybookId.join(',')
                                    : undefined,
                              accountIds:
                                 filters.accountId && filters.accountId.length > 0
                                    ? filters.accountId.join(',')
                                    : undefined,
                              docNumber: filters.docNumber || undefined,
                              fromDate: filters.fromDate || undefined,
                              toDate: filters.toDate || undefined,
                              txnType: filters.txnType !== '' ? filters.txnType : undefined,
                           }),
                        );
                     }

                     toast.success('Record updated successfully');
                  } catch (error) {
                     console.error('❌ Error updating voucher:', error);
                     toast.error('Error updating record');
                     setUpdateFormLoading(false);
                  }
               }}
               receivedAmount={receivedAmount}
               setReceivedAmount={setReceivedAmount}
               transactionType={transactionType}
               fetchBankVoucherData={() => fetchBankVoucherData()}
            />
         )}

         <DeleteDialog
            isDeleteDialogOpen={isDeleteDialogOpen}
            setDeleteDialogOpen={setDeleteDialogOpen}
            handleDelete={handleDelete}
            title="Bank Voucher"
         />

         <CashBankFilterModal
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            onApplyFilters={handleApplyFilters}
            initialFilters={filters}
            isBankPageTrue={isBankPageTrue}
         />

         {isOpenSingleView && (
            <div className="fixed inset-0 z-[999]">
               {isModalLoading ? (
                  <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[9999]">
                     <Loader />
                  </div>
               ) : (
                  <ViewSingleCashBankData
                     isOpenSingleView={isOpenSingleView}
                     onClose={() => {
                        setIsOpenSingleView(false);
                     }}
                     singleEntity={singleEntity}
                     formType="voucher"
                     isBankPageTrue={isBankPageTrue}
                     UserRights={bankPaymentRight && bankReceiveRight}
                     paymentRight={bankPaymentRight}
                     receiveRight={bankReceiveRight}
                     startEditing={(data) => {
                        setIsOpenSingleView(false);
                        setTimeout(() => {
                           startEditing(data.id, data);
                        }, 100);
                     }}
                  />
               )}
            </div>
         )}

         <ColumnVisibilityModal
            isOpen={isColumnModalOpen}
            onClose={() => setIsColumnModalOpen(false)}
            columnVisibility={columnVisibility}
            setColumnVisibility={setColumnVisibility}
            user={user}
         />

         <DeletePasswordModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onConfirm={handleDeleteClick}
            id={dataId}
         // deleteApi={deleteReceiveInventory}
         // dispatch={dispatch}
         />

         <MultiDeletePasswordModal
            isOpen={multiPass}
            onClose={() => {
               setMultiPass(false);
               setMultiDeleteData([]);
            }}
            onConfirm={() => handleMultiDeleteClick(multiDeleteData)}
         />

         <Modal
            isOpen={isImportModalOpen}
            onClose={() => {
               setIsImportModalOpen(false);
               setExcelFile(null);
               setImportAccountId('');
               setImportDaybookId('');
               setAccountShow(false);
            }}
            isCentered
            motionPreset="scale">
            <ModalOverlay backdropFilter="blur(4px)" />

            <ModalContent borderRadius="2xl" boxShadow="2xl">
               <ModalHeader textAlign="center">
                  <Icon as={BsFileEarmarkExcel} boxSize={10} color="green.500" mb={2} />
                  Import Voucher Excel
               </ModalHeader>
               <ModalCloseButton />

               <ModalBody>
                  <VStack spacing={5}>
                     <Text fontSize="sm" color="gray.500" textAlign="center">
                        Upload your Excel file (.xls or .xlsx) to import account data
                     </Text>

                     <Box
                        w="100%"
                        p={4}
                        bg="gray.50"
                        border="1px solid"
                        borderColor="gray.200"
                        borderRadius="xl"
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between">
                        <Box>
                           <Text fontSize="sm" fontWeight="semibold">
                              Need a sample Excel format?
                           </Text>
                           <Text fontSize="xs" color="gray.500">
                              Download a demo Excel file to see the Excel format
                           </Text>
                        </Box>

                        <Button
                           size="sm"
                           variant="outline"
                           colorScheme="green"
                           leftIcon={<BsFileEarmarkExcel />}
                           rightIcon={<DownloadIcon />}
                           onClick={handleDownloadDemoExcel}>
                           Download
                        </Button>
                     </Box>

                     {/* Suspense Account Toggle */}
                     <Box w="100%">
                        <Checkbox
                           colorScheme="green"
                           isChecked={accountShow}
                           onChange={(e) => {
                              setAccountShow(e.target.checked);

                              // only reset account
                              if (!e.target.checked) {
                                 setImportAccountId('');
                              } else {
                                 const suspenceAccounts = userData.find((account) =>
                                    account.name.toLowerCase().includes('suspence'),
                                 );
                                 console.log('suspenceAccounts', suspenceAccounts);
                                 setImportAccountId(suspenceAccounts.id || '');
                              }
                           }}>
                           Suspense Account
                        </Checkbox>
                     </Box>

                     {/* <Select
                        placeholder="Select daybook"
                        value={importDaybookId}
                        onChange={(e) => setImportDaybookId(e.target.value)}
                        size="md"
                        borderRadius="lg"
                     >
                        {daybookData.filter((daybook) => daybook.type === 14).map((daybook) => (
                           <option key={daybook.id} value={daybook.id}>
                              {daybook.name}
                           </option>
                        ))}
                     </Select> */}

                     <FormControl>
                        {renderDynamicDropdown(
                           'daybookId',
                           'Daybook',
                           daybookData.filter((daybook) => daybook.type === 14) || [],
                           {
                              errorName: 'header.daybookId',
                              value: importDaybookId || '',
                              onChange: (value) => setImportDaybookId(value),
                              focusBorderColor: 'blue.500',
                              _focus: {
                                 boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                              },
                              showCustomNoOptions: true,
                              openfrom: 'daybook',
                           },
                           errors,
                           textColor,
                           true,
                           'Select Cash Account',
                        )}
                     </FormControl>

                     {accountShow && (
                        // <Select
                        //    placeholder="Select account"
                        //    value={importAccountId}
                        //    onChange={(e) => setImportAccountId(e.target.value)}
                        //    size="md"
                        //    borderRadius="lg"
                        //    isDisabled={!accountShow}
                        // >
                        //    {userData.map((account) => (
                        //       <option key={account.id} value={account.id}>
                        //          {account.name}
                        //       </option>
                        //    ))}
                        // </Select>
                        <AccountSelect
                           name="accountId"
                           options={userData}
                           label="Account"
                           value={importAccountId}
                           errors={{}}
                           errorName=""
                           isClearable
                           isSearchable
                           onChange={(value) => setImportAccountId(value)}
                           showCustomNoOptions={true}
                           openfrom="salesdaybook"
                        // glGroup={targetGlGroup}
                        // errors={errors}
                        />
                     )}

                     {/* Upload Box */}
                     <Box
                        w="100%"
                        p={6}
                        border="2px dashed"
                        borderColor="green.400"
                        borderRadius="xl"
                        textAlign="center"
                        cursor="pointer"
                        transition="all 0.3s ease"
                        _hover={{
                           bg: 'green.50',
                           borderColor: 'green.500',
                           transform: 'scale(1.02)',
                        }}
                        position="relative">
                        <Icon as={FiUploadCloud} boxSize={8} color="green.500" mb={2} />

                        <Text fontWeight="medium">Click to upload Excel file</Text>

                        <Text fontSize="xs" color="gray.500">
                           Only .xls & .xlsx files are supported
                        </Text>

                        <input
                           type="file"
                           accept=".xls,.xlsx"
                           onChange={(e) => handleExcelUpload(e.target.files[0])}
                           style={{
                              position: 'absolute',
                              inset: 0,
                              opacity: 0,
                              cursor: 'pointer',
                           }}
                        />
                     </Box>

                     {/* Selected file preview */}
                     {excelFile && (
                        <Fade in>
                           <Box
                              w="100%"
                              p={3}
                              bg="green.50"
                              borderRadius="lg"
                              border="1px solid"
                              borderColor="green.200">
                              <Text fontSize="sm" color="green.700">
                                 📄 {excelFile.name}
                              </Text>
                           </Box>
                        </Fade>
                     )}
                  </VStack>
               </ModalBody>

               <ModalFooter justifyContent="space-between">
                  <Button
                     variant="ghost"
                     onClick={() => {
                        setIsImportModalOpen(false);
                        setExcelFile(null);
                        setImportAccountId('');
                        setImportDaybookId('');
                        setAccountShow(false);
                     }}>
                     Cancel
                  </Button>

                  <Button
                     colorScheme="green"
                     leftIcon={<BsFileEarmarkExcel />}
                     onClick={handleImportExcel}
                     isDisabled={!excelFile || !importDaybookId || (accountShow && !importAccountId)}
                     // isLoading={isImporting}
                     loadingText="Importing..."
                     px={6}>
                     Import
                  </Button>
               </ModalFooter>
            </ModalContent>
         </Modal>

         <LogView isOpen={isOpenLog} onClose={onCloseLog} title="Log" entityType="voucher" id={logId} />

         <style jsx>{`
            .custom-scrollbar {
               scrollbar-width: thin;
               scrollbar-color: rgba(155, 155, 155, 0.5) transparent;
            }
            .custom-scrollbar::-webkit-scrollbar {
               width: 6px;
               height: 6px;
            }
            .custom-scrollbar::-webkit-scrollbar-track {
               background: transparent;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb {
               background-color: rgba(155, 155, 155, 0.5);
               border-radius: 20px;
               border: transparent;
            }
         `}</style>
      </Box>
   );
}
